export const FILE_BUCKET = {
  UnitReceiptMonitoring: "unit-receipt-monitoring-bucket",
  AssetTransfer: "asset-transfer",
} as const;

export type EnumFileBucket = (typeof FILE_BUCKET)[keyof typeof FILE_BUCKET];
